import * as _ from "lodash"
import {MessageType} from "../PA.Core/PA.Core.IF.Basic";
import {EventPortfolioBO} from "./EventPortfolioBO";
import {WB_CustomerRow, WB_EventPortfolioRow} from "../PA.Core/PAdbSchemaRows";
import {debuglog} from "util";
import {PAdbContext} from "../PA.Core/PAdbContext";
import {esWB_Event_Portfolio} from "../PA.Core/PAdbSchema";
import {toLower} from "lodash";

export class EventPortfolioBOValidation {

    static async ValidateFields(aBO: EventPortfolioBO): Promise<void> {
        const self = this;
        let dbContext = new PAdbContext({})
        let rowPresent: any = {}
        let allDuplicateRows: any[] = []
        let portfolioRows = await dbContext.findAll(esWB_Event_Portfolio, {where: {DELETED_IND: {neq: '1'}}})
        _.forEach(portfolioRows, (row: WB_EventPortfolioRow) => {

            if (row.cif.PORTFOLIO_ID !== aBO.WB_EventPortfolio.cif.PORTFOLIO_ID &&
                toLower(row.cif.PORTFOLIO_NAME) === toLower(aBO.WB_EventPortfolio.cif.PORTFOLIO_NAME)) {
                rowPresent = {
                    name: row.cif.PORTFOLIO_NAME,
                    id: row.cif.PORTFOLIO_ID
                }
                allDuplicateRows.push(rowPresent)
            }
        })

        if (!_.isEmpty(rowPresent)) {
            self.addMessage(aBO, "duplicateNames", 'There is an existing portfolio with the same name' +
                '\nPortfolio name:  ' + rowPresent?.name +
                '\nPortfolio Id: ' + rowPresent?.id
            )
        } else {
            aBO.ValidateMessageProvider.removeMessage("duplicateNames")
        }


    }

    private static addMessage(aBO: EventPortfolioBO, code: string, message: string): void {
        aBO.ValidateMessageProvider.addMessage(
            {
                code: code,
                type: MessageType.Error,
                title: message,
                description: "",
                subtitle: "",
                count: 0
            });
    }
}